import React from "react";
import Grade11ScienceMenu from "./Grade11ScienceMenu";

export default function Grade11ScienceLesson() {
  return <Grade11ScienceMenu />;
}